import React from 'react';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';


function GroupState({ etatList, facultatifList }) {
  const mappingStateValue = { 'attente': 0, 'valide': 1, 'manquant': 2, 'rejet': 3 }

  var highestState = 'attente';
  var count = 0;
  var total = 0

  for (let i = 0; i < etatList.length; i++) {
    const etat = etatList[i];

    if (!facultatifList[i]) {
      total++;
      if (mappingStateValue[etat] > mappingStateValue[highestState]) {
        highestState = etat;
        count = 1;
      } else if (mappingStateValue[etat] === mappingStateValue[highestState]) {
        count += 1;
      }
    }
  }

  if (total === 0) {
    return (
      <>
        <div className='col-span-4 w-full flex items-center justify-end gap-4 text-red-600 font-medium'>
          <div className='inline-block'></div>
          <div className='inline-block'></div>
        </div>
      </>
    )
  }

  switch (highestState) {
    case 'manquant':
      return (
        <>
          <div className='col-span-4 w-full flex items-center justify-end gap-4 text-red-600 font-medium'>
            <div className='inline-block'>{count}/{total} Manquant(s)</div>
            <div className='inline-block'><CloseIcon /></div>
          </div>
        </>
      )
    case 'attente':
      return (
        <>
          <div className='col-span-4 w-full flex items-center justify-end gap-4 text-orange-400 font-medium'>
            <div className='inline-block'>{count}/{total} Déposé(s)</div>
            <div className='inline-block'><MoreHorizIcon /></div>
          </div>
        </>
      )
    case 'valide':
      return (
        <>
          <div className='col-span-4 w-full flex items-center justify-end gap-4 text-green-600 font-medium'>
            <div className='inline-block'>{count}/{total} Validé(s)</div>
            <div className='inline-block'><CheckIcon /></div>
          </div>
        </>
      )
    case 'rejet':
      return (
        <>
          <div className='col-span-4 w-full flex items-center justify-end gap-4 text-red-600 font-medium'>
            <div className='inline-block'>{count}/{total} Rejeté(s)</div>
            <div className='inline-block'><CloseIcon /></div>
          </div>
        </>
      )
  }
};

export default GroupState;